import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedMachine = () => {
    // Retrieve user data from localStorage
    const userData = JSON.parse(localStorage.getItem('BondTimeportNoData'));

    // Check if user is logged in and has "Success" status
    const isAuthenticated = userData && (userData[0]?.PORTNO.length > 0 ) ;

    return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedMachine;
